import { Typography } from "@mui/material";
import {
  ACTION_TYPE,
  ACTIONABLE_ITEM_OBJ_MAPPING,
  NULL_STRING,
} from "../../utils/constants";
import FormatISODateTime from "../../../../../../../global/FormatISODateTime";

export default function FollowUpAccordionDetails({ accordionItemContent }) {

   const getTitle = () => {
      if (accordionItemContent.actionType === ACTION_TYPE.CLIENT_FOLLOW_UP.toString()){
          return accordionItemContent?.[ACTIONABLE_ITEM_OBJ_MAPPING[accordionItemContent.actionType]]?.client.name;
      }
        return accordionItemContent?.[
          ACTIONABLE_ITEM_OBJ_MAPPING[accordionItemContent.actionType]
        ]?.name;
    };

  const followUpFor = getTitle();
  const dueDate = FormatISODateTime(
    new Date(accordionItemContent.completedAt).toISOString()
  );
  const relativeDueDate = accordionItemContent.relativeDueDate;
  const followUpDetails = accordionItemContent.actionDetail || NULL_STRING;
  const completedAt = FormatISODateTime(
    new Date(accordionItemContent.completedAt).toISOString()
  );
  const completedBy = accordionItemContent.completedBy.name;
  const followUpDetailsTextColor = followUpDetails === NULL_STRING ? 'text-gray-500' : 'text-black';
  return (
    <div>
      <Typography className={`text-sm p-1 capitalize`}>
        <span className={`font-bold`}>{"For: "}</span>
        {followUpFor}
      </Typography>
      <Typography
        className={`text-sm flex flex-row justify-between items-baseline p-1`}
      >
        <span className={`font-bold`}>{"Due Date: "}</span>
        {dueDate + " "}
        <span className={`italic text-xs`}>{"(" + relativeDueDate + ")"}</span>
      </Typography>
      <div className={`flex flex-col`}>
        <Typography
          className={`text-sm flex flex-row justify-between items-baseline p-1 font-bold`}
        >
          {"Follow-up Details: "}
        </Typography>
        <Typography className={`text-sm p-1 ${followUpDetailsTextColor}`}>{followUpDetails}</Typography>
      </div>
      <Typography className={`text-sm p-1`}>
        <span className={`font-bold`}>{"Completed By: "}</span>
        {completedBy}
      </Typography>
      <Typography className={`text-sm p-1`}>
        <span className={`font-bold`}>{"Completed At: "}</span>
        {completedAt}
      </Typography>
    </div>
  );
}
